const normalizeTag = (value = "") => String(value).trim().replace(/^#+/, "").toLowerCase();

const collectTags = (entries = []) => {
  const seen = new Set();

  entries.forEach(entry => {
    const tags = Array.isArray(entry.tags) ? entry.tags : [];
    tags.forEach(tag => {
      const normalized = normalizeTag(tag);
      if (normalized) {
        seen.add(normalized);
      }
    });
  });

  return Array.from(seen);
};

const getGuidelinesSelectPlaceholder = (isMulti = false, language = "en") => {
  const normalizedLanguage = String(language || "en").toLowerCase().split("-")[0];
  const placeholders = {
    en: { single: "Select", multi: "Select tags" },
    hu: { single: "Válassz", multi: "Válassz tageket" },
    de: { single: "Auswählen", multi: "Tags auswählen" },
    it: { single: "Seleziona", multi: "Seleziona tag" },
    cn: { single: "请选择", multi: "请选择标签" }
  };

  const locale = placeholders[normalizedLanguage] || placeholders.en;
  return locale[isMulti ? "multi" : "single"];
};

module.exports = {
  normalizeTag,
  collectTags,
  getGuidelinesSelectPlaceholder
};
